import { Pipe, PipeTransform } from '@angular/core';

import * as moment from 'moment';

moment.locale('es');

@Pipe({
  name: 'formatDate'
})
export class FormatDatePipe implements PipeTransform {

  transform(date: string, format = 'DD/MM/YYYY') {
    return moment(date).format(format);
  }

}
